import type { FieldHelpContent } from "@/components/ui/field-help";

/** Sparse desk doc field help — plan/46 + plan/35 doc date / fulfillment. */
export const deskDocHelp = {
  docDate: {
    title: "Date",
    summary:
      "Business date for this order — books, lists, and aging use it. Not when the row was encoded (that stays Created).",
    example:
      "Supplier invoice is dated yesterday → set Date to yesterday even if you enter the PO today.",
    detail:
      "Backdating changes Date only; Created never moves. Org settings can cap how far back (soft warn or hard reject).",
    useCases: [
      "Match a customer PO or supplier invoice date for reporting.",
      "Correct a mistyped day without voiding a posted order.",
    ],
  },
  fulfillmentMethod: {
    title: "Fulfillment",
    summary:
      "How goods leave you: Pickup (customer collects) or Delivery (you ship). Unset means direct fulfill without a pickup/delivery method label.",
    example:
      "Walk-in pays and takes goods → Pickup. Same-day truck to their shop → Delivery.",
    detail:
      "Method can change copy on deliver (Picked up vs Delivered) and whether org “require in-transit” soft-warns before posting.",
    useCases: [
      "Counter sell with later pickup → set Pickup so the queue reads clearly.",
      "Leave Unset for simple ship-or-hand-over shops that don’t need the distinction.",
    ],
  },
} as const satisfies Record<string, FieldHelpContent>;
